module.exports = require("@splunk/visualizations-shared/colorUtils");